import React, { useState } from 'react';
import Footer from '../components/reusableComponents/Footer';
import Headers from '../components/reusableComponents/Headers';
import { Container, Grid, Divider, Box } from '@material-ui/core';
import { toggleEnquiryModal } from '../reducers/UiReducer';
import Carousel from '../components/reusableComponents/Carousel';
import CarouselDetails from '../components/reusableComponents/CarouselDetials';
import EnquiryModal from '../components/reusableComponents/EnquiryModal';
import { useDispatch } from 'react-redux';
const data = [
	{
		fontawsClass: 'fa fa-building-o',
		title: 'Our Offices',
		desc: 'Located across the country, ready to assist in planning & booking your perfect vacation.',
		footer: 'Locate Us',
	},
	{
		fontawsClass: 'fa fa-phone',
		title: 'Call us',
		desc: "Request a quote, or just chat about your next vacation. We're always happy to help!",
		footer: '(+91) 8877773388',
	},
	{
		fontawsClass: 'fa fa-envelope',
		title: 'Write to us',
		desc: 'Be it an enquiry, feedback or a simple suggestion, write to us.',
		footer: 'info@musafirbazar.com',
	},
	{
		fontawsClass: 'fa fa-share-alt',
		title: 'Connect with us',
		desc: 'Check out reviews, podcasts, blogs and more...',
		footer: '',
	},
];
const DetailSection = () => {
	const dispatch = useDispatch();
	const [tab, setTab] = useState('one');
	const handleChange = (val) => {
		setTab(val);
	};
	return (
		<>
			<Headers />
			<Divider />
			<Container style={{ marginTop: 20, marginBottom: 50 }}>
				<Grid container spacing={4}>
					<Grid item xs={12} lg={8}>
						<h2>Women's Special Shimla Manali</h2>
						<span style={{ color: 'grey', fontSize: 16, marginBottom: 20 }}>
							7 Days - 1 Country | 4 Cities
						</span>
						<CarouselDetails />

						<h4 style={{ marginTop: 20 }}>Package Includes</h4>
						<Grid
							container
							style={{ color: 'grey', marginBottom: 20, marginTop: 20 }}
							spacing={2}>
							{Array.from(Array(5)).map(() => {
								return (
									<Grid item xs={2}>
										<Box
											style={{
												textAlign: 'center',
												padding: '20px',
												border: '1px solid lightgray',
												borderRadius: '12px',
												background: 'white',
											}}>
											<i class='fa-solid fa-hotel'></i>
											<p>Hotels</p>
										</Box>
									</Grid>
								);
							})}
						</Grid>
						<h4 style={{ marginTop: 20 }}>Detailed Tour Price</h4>
						<Box
							style={{
								display: 'flex',
								justifyContent: 'space-between',
								border: '1px solid',
								padding: '20px',
								borderBottom: 'none',
								borderTopLeftRadius: 5,
								borderTopRightRadius: 5,
							}}>
							<span>Room Type</span>
							<span>Basic Price</span>
						</Box>
						<Box
							style={{
								display: 'flex',
								justifyContent: 'space-between',
								border: '1px solid',
								padding: '20px',
								borderBottomLeftRadius: 5,
								borderBottomRightRadius: 5,
							}}>
							<span>Twin Sharing</span>
							<span>₹ 85645</span>
						</Box>
						<br />
						<br />
						<br />
					</Grid>
					<Grid
						item
						xs={12}
						lg={4}
						style={{
							boxShadow: '0px 10px 15px -3px rgba(0,0,0,0.1)',
							marginTop: 50, // padding: 60,
						}}>
						<Grid container spacing={4} style={{ padding: 20 }}>
							<Grid item xs={6}>
								<span style={{ color: 'green', fontSize: 14 }}>
									SUPER DEAL PRICE
								</span>
								<p style={{ fontSize: '12px', color: 'grey' }}>STARTS FROM</p>
								<h2 style={{ fontWeight: 'bold' }}>₹96,000</h2>
							</Grid>
							<Grid item xs={6}>
								<Box
									onClick={() => dispatch(toggleEnquiryModal(true))}
									style={{
										border: '1px solid grey',
										padding: '6px',
										textAlign: 'center',
										borderRadius: '5px',
										background: 'yellow',
										cursor: 'pointer',
									}}>
									<span style={{ fontSize: 14 }}>Enquiry Now</span>
								</Box>
							</Grid>
						</Grid>
						<Box>
							<span style={{ marginLeft: 20, fontSize: 20 }}>
								Tour includes
							</span>
							<Box
								style={{
									justifyContent: 'space-between',
									display: 'flex',
									marginLeft: 20,
									marginTop: 10,
								}}>
								<Box style={{ textAlign: 'center' }}>
									<i class='fa-solid fa-hotel'></i>
									<br />
									<span style={{ fontSize: 12, color: 'grey' }}>Hotel</span>
								</Box>
								<Box style={{ textAlign: 'center' }}>
									<i class='fa-solid fa-hotel'></i>
									<br />
									<span style={{ fontSize: 12, color: 'grey' }}>Hotel</span>
								</Box>
								<Box style={{ textAlign: 'center' }}>
									<i class='fa-solid fa-hotel'></i>
									<br />
									<span style={{ fontSize: 12, color: 'grey' }}>Hotel</span>
								</Box>
								<Box style={{ textAlign: 'center' }}>
									<i class='fa-solid fa-hotel'></i>
									<br />
									<span style={{ fontSize: 12, color: 'grey' }}>Hotel</span>
								</Box>
								<Box style={{ textAlign: 'center' }}>
									<i class='fa-solid fa-hotel'></i>
									<br />
									<span style={{ fontSize: 12, color: 'grey' }}>Hotel</span>
								</Box>
							</Box>
						</Box>
						<Box style={{ marginTop: 20 }}>
							<span style={{ marginLeft: 20, fontSize: 20 }}>
								Why travel with Musafir Bazar ?
							</span>
							<ul>
								<li style={{ color: 'grey' }}>
									Expert tour manager all throughout the tour
								</li>
								<li style={{ color: 'grey' }}>
									Expert tour manager all throughout the tour
								</li>
								<li style={{ color: 'grey' }}>
									Expert tour manager all throughout the tour
								</li>
							</ul>
						</Box>
						{/* <Box style={{ border: '1px solid grey' }}>
								<span>Enquiry</span>
							</Box>
							<Box style={{ border: '1px solid grey' }}>
								<span>Book Now</span>
							</Box> */}
					</Grid>
				</Grid>
				<Grid container>
					<Grid item xs={12} lg={8}>
						<span style={{ fontSize: 24 }}>Tour Information</span>
						<br></br>
						<span style={{ color: 'grey', fontSize: 13 }}>
							Read this to prepare for your tour in the best way!
						</span>

						<Box
							style={{
								border: '1px solid grey',
								borderTopLeftRadius: 12,
								borderTopRightRadius: 12,
								marginTop: 10,
								marginBottom: 20,
							}}>
							<Box
								style={{
									background: '#29499a',
									display: 'flex',
									justifyContent: 'space-between',

									// borderRadius: 12,
									borderTopLeftRadius: 12,
									borderTopRightRadius: 12,
								}}>
								<Box
									onClick={() => handleChange('one')}
									style={{
										width: '100%',
										padding: 12,
										background: tab === 'one' ? 'white' : '',
										textAlign: 'center',
										cursor: 'pointer',
									}}>
									<span style={{ color: tab === 'one' ? 'black' : 'white' }}>
										Inclusion
									</span>
								</Box>
								<Box
									onClick={() => handleChange('two')}
									style={{
										width: '100%',
										padding: 12,
										textAlign: 'center',
										background: tab === 'two' ? 'white' : '',
										cursor: 'pointer',
									}}>
									<span style={{ color: tab === 'two' ? 'black' : 'white' }}>
										Exclusion
									</span>
								</Box>
								<Box
									onClick={() => handleChange('three')}
									style={{
										width: '100%',
										padding: 12,
										textAlign: 'center',
										background: tab === 'three' ? 'white' : '',
										cursor: 'pointer',
									}}>
									<span style={{ color: tab === 'three' ? 'black' : 'white' }}>
										Advance preparation for the tour
									</span>
								</Box>
							</Box>
							<ul style={{ marginTop: 20 }}>
								<li style={{ marginTop: 20 }}>
									To and Fro economy class air ticket (Ex-Mumbai) with current
									airport taxes
								</li>
								<li style={{ marginTop: 20 }}>
									To and Fro economy class air ticket (Ex-Mumbai) with current
									airport taxes
								</li>
								<li style={{ marginTop: 20 }}>
									To and Fro economy class air ticket (Ex-Mumbai) with current
									airport taxes
								</li>
								<li style={{ marginTop: 20 }}>
									To and Fro economy class air ticket (Ex-Mumbai) with current
									airport taxes
								</li>

								<li style={{ marginTop: 20 }}>
									To and Fro economy class air ticket (Ex-Mumbai) with current
									airport taxes
								</li>
								<li style={{ marginTop: 20 }}>
									To and Fro economy class air ticket (Ex-Mumbai) with current
									airport taxes
								</li>
							</ul>
						</Box>
						<span style={{ fontSize: 24 }}>
							Cancellation Policy & Payment Terms
						</span>
						<br></br>
						<span style={{ color: 'grey', fontSize: 13 }}>
							Read this to prepare for your tour in the best way!
						</span>
						<Box style={{ marginTop: 20 }}>
							<Grid container>
								<Grid
									item
									xs={4}
									style={{
										background: '#29499a',
										padding: 10,
										borderTopLeftRadius: 12,
									}}>
									<span style={{ fontSize: 14, color: 'white' }}>
										Cancellation received no. of days prior to departure
									</span>
								</Grid>
								<Grid
									item
									xs={8}
									style={{
										border: '1px solid grey',
										borderTopRightRadius: 12,
									}}>
									<Box
										style={{
											justifyContent: 'space-between',
											display: 'flex',
										}}></Box>
								</Grid>
							</Grid>
							<Grid container>
								<Grid
									item
									xs={4}
									style={{
										background: '#29499a',
										padding: 10,
										borderBottomLeftRadius: 12,
									}}>
									<span style={{ fontSize: 14, color: 'white' }}>
										Cancellation fee applicable on Net Tour Price (per person)
									</span>
								</Grid>
								<Grid
									item
									xs={8}
									style={{
										border: '1px solid grey',
										borderBottomRightRadius: 12,
									}}></Grid>
							</Grid>
						</Box>
						<Box style={{ marginTop: 20 }}>
							<span style={{ fontSize: 22 }}>Payment Terms</span>
							<br />
							<span style={{ fontSize: 14, color: 'grey' }}>
								Guest can pay by Cash/cheque/ Demand Draft / Debit card / credit
								card For Debit / Credit Card payment additional 0.50 %
								convenience charge will be applicable Cheque / Demand draft
								should be in favour of " Veena Patil Hospitality Pvt ltd"
							</span>
							<br />
							<br />
							<span style={{ fontSize: 22 }}>Remarks</span>
							<br />
							<ul>
								<li style={{ fontSize: 14, color: 'grey' }}>
									All meals are provided by Veena World in case the flight
									reaches the stipulated destination early morning or leaves
									destination late in the evening.
								</li>
								<li style={{ fontSize: 14, color: 'grey' }}>
									All meals are provided by Veena World in case the flight
									reaches the stipulated destination early morning or leaves
									destination late in the evening.
								</li>
								<li style={{ fontSize: 14, color: 'grey' }}>
									All meals are provided by Veena World in case the flight
									reaches the stipulated destination early morning or leaves
									destination late in the evening.
								</li>
							</ul>
						</Box>
					</Grid>
					<Grid item xs={12} lg={4}></Grid>
				</Grid>
			</Container>
			<Container style={{ marginTop: 20, marginBottom: 20 }}>
				<Grid container spacing={4}>
					{data.map((r, index) => {
						return (
							<Grid item xs={12} lg={3}>
								<Box>
									<i class={r.fontawsClass} aria-hidden='true'></i>
									<span style={{ marginLeft: 10, fontSize: 20 }}>
										{r.title}
									</span>
									<br />
									<p style={{ fontSize: 12 }}>{r.desc}</p>
									{index === 3 ? (
										<>
											<i
												class='fa fa-facebook-square'
												aria-hidden='true'
												style={{ fontSize: 30 }}></i>
											<i
												class='fa fa-youtube-play'
												aria-hidden='true'
												style={{ fontSize: 30, marginLeft: 10 }}></i>
											<i
												class='fa fa-linkedin'
												aria-hidden='true'
												style={{ fontSize: 30, marginLeft: 10 }}></i>
											<i
												class='fa fa-instagram'
												aria-hidden='true'
												style={{ fontSize: 30, marginLeft: 10 }}></i>
											<i
												class='fa fa-twitter'
												aria-hidden='true'
												style={{ fontSize: 30, marginLeft: 10 }}></i>
										</>
									) : (
										<span style={{ color: 'darblue', fontWeight: 'bold' }}>
											{r.footer}
										</span>
									)}
								</Box>
							</Grid>
						);
					})}
				</Grid>
			</Container>
			<EnquiryModal />
			<Footer />
		</>
	);
};

export default DetailSection;
